import { Controller } from "stimulus";

// Mobile tab bar: slides the selected pill to a tapped tab while Turbo fetches the page. The new page
// renders the pill under its own tab already; handOff passes it where the old pill had got to, so a
// response landing mid-slide carries the slide on instead of jumping.
let pendingHandOff = null;

export default class TabBarComponent extends Controller {
  static targets = ["nav", "indicator", "tab"];
  static values = { activeIndex: Number };

  // A tap leaves this page's DOM (and so its Turbo snapshot) showing the tapped tab. Snap back to what
  // the server rendered without animating, or restoring that snapshot would slide the pill in.
  connect() {
    const from = pendingHandOff && Date.now() - pendingHandOff.at < 1000 ? pendingHandOff.translate : null;
    pendingHandOff = null;

    this.indicatorTarget.style.transition = "none";
    this.show(this.activeIndexValue);
    if (from) this.indicatorTarget.style.translate = from;
    this.indicatorTarget.getBoundingClientRect(); // flush styles before the transition comes back
    this.indicatorTarget.style.transition = "";
    this.indicatorTarget.style.translate = "";
  }

  select(event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const index = this.tabTargets.indexOf(event.currentTarget);
    if (index === this.currentIndex) return;

    this.show(index);
  }

  // Only a pill still sliding is handed on, which chains through Turbo's cached preview of the tapped
  // page to its real render, while leaving a page at rest (back/forward) doesn't slide the next one in.
  handOff() {
    if (this.indicatorTarget.getAnimations().length === 0) return;

    pendingHandOff = { translate: getComputedStyle(this.indicatorTarget).translate, at: Date.now() };
  }

  show(index) {
    this.navTarget.style.setProperty("--active-index", index);
    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.setAttribute("aria-current", "page");
      } else {
        tab.removeAttribute("aria-current");
      }
    });
  }

  get currentIndex() {
    return this.tabTargets.findIndex((tab) => tab.hasAttribute("aria-current"));
  }
}
